import { Pipe, PipeTransform } from '@angular/core';
import { UnderageBirthdatePipe } from '../underage-birthdate/underage-birthdate.pipe';

@Pipe({
  name: 'underageMonth',
  standalone: true,
})
export class UnderageMonthPipe implements PipeTransform {
  public transform(value: string, ...args: string[]): boolean {
    if (!value) {
      return null;
    }

    const month = value.trim();
    if (month.length !== 2) {
      return false;
    }

    const day = args[0];
    const year = args[1];
    if (!day || !year) {
      const monthAsNumber = parseInt(value, 10);
      return monthAsNumber > 0 && monthAsNumber <= 12;
    }

    return new UnderageBirthdatePipe().transform(day, month, year);
  }
}
